import { useTranslation } from 'react-i18next';
import { useGetUserInfo } from '../../../domains/user/ui/hooks/useGetUserInfo';
import { useCreateComment } from '../hooks/useCreateComment';
import { useInvalidateSceneCommentQueries } from '../hooks/useInvalidateSceneCommentQueries';
import { CommentAuthorAvatar } from './CommentAuthorAvatar';

interface CommentDetailReplyInputFieldProps {
  adaptedFictionEditionId: string;
  threadCommentId: string;
  adaptedFictionPreviewId?: string;
  sceneId?: string;
}

export const CommentDetailReplyInputField = ({
  adaptedFictionEditionId,
  threadCommentId,
  adaptedFictionPreviewId,
  sceneId
}: CommentDetailReplyInputFieldProps) => {
  const { t } = useTranslation();
  const { invalidateRepliesAndDetail } = useInvalidateSceneCommentQueries();

  const {
    comment,
    setComment,
    isAnonymous,
    setIsAnonymous,
    handleCreateAdaptedFictionEditionComment
  } = useCreateComment({
    adaptedFictionEditionId,
    adaptedFictionPreviewId,
    sceneId
  });

  const { data: user } = useGetUserInfo();

  const handleCreateReply = async () => {
    await handleCreateAdaptedFictionEditionComment(threadCommentId);
    await invalidateRepliesAndDetail(adaptedFictionEditionId, threadCommentId);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 pt-[16px] pb-[calc(16px+env(safe-area-inset-bottom))] px-[20px] flex items-center gap-[10px] border-t border-separator1 bg-background-light dark:bg-background-dark">
      <div className="relative w-[34px] h-[34px]">
        <CommentAuthorAvatar
          anonymous={isAnonymous}
          thumbnailUrl={user?.baseUserProfile?.thumbnailUrl ?? undefined}
          size={34}
        />
        <button
          type="button"
          aria-label="익명 전환"
          className="absolute bottom-0 right-[-2px] w-[12px] h-[12px] rounded-full bg-primary-light dark:bg-primary-dark border border-pure-white dark:border-pure-black"
          onClick={() => setIsAnonymous(!isAnonymous)}
        />
      </div>

      <div className="flex items-center gap-[10px] justify-between w-full">
        <input
          type="text"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t('SceneCommentsDetail.placeholder') as string}
          className="text-[15px] font-semibold leading-[18px] text-text-main-lv2 bg-transparent outline-none placeholder:font-medium placeholder:text-placeholder-light dark:placeholder:text-placeholder-dark"
        />

        {comment.trim() && (
          <button
            type="button"
            className="text-[15px] font-semibold leading-[18px] text-primary-light dark:text-primary-dark"
            onClick={handleCreateReply}
          >
            {t('SceneCommentsDetail.send')}
          </button>
        )}
      </div>
    </div>
  );
};
